// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import styled from '@emotion/styled';

import {
  spacing,
  fontSize,
  fontWeight,
  zIndex,
  mediaMax,
} from 'presentations/views/styles';
import { black, gray01, gray04 } from 'presentations/views/styles/color';
import Dialog from 'presentations/views/components/atoms/Dialog';
import Icon from 'presentations/views/components/atoms/Icon';
import Link from 'presentations/views/components/atoms/Link';
import DialogSubmitField from 'presentations/views/components/molecules/DialogSubmitField';
import { helpPath } from 'presentations/routes/path';
import { UnavailableInfomation } from 'presentations/api/schema/calendar_event';
import { CalendarUnavailableReasonType } from 'presentations/api/schema/calendar_event/enum';
import { providerTypeName } from 'domains/models/calendar/providerType';

export interface Props {
  onClose?: Function;
  reasons: UnavailableInfomation[];
  viewerUid?: string;
}

export default function Component(props: Props) {
  const t = translateInComponent(translations);

  return (
    <Dialog
      isOpen
      title={t('title')}
      actions={
        <ActionContainer>
          <ShowDetailLink href={helpPath('7155118')} target="_blank">
            <Icon name="chevron-right" color="primary" />
            {t('Show detail')}
          </ShowDetailLink>
          <DialogSubmitField
            onCancel={props.onClose}
            cancelLabel={t('Close')}
          />
        </ActionContainer>
      }
      onClose={props.onClose}
      scroll
      maxHeight="50vh"
      mobileMaxHeight="100%"
      zIndex={zIndex(1500)}
      disableRestoreFocus
    >
      <Content>
        {props.reasons.map((reason, index) => (
          <ReasonItem key={index}>
            <ReasonTitle>{t(`reason ${reason.reason}.title`)}</ReasonTitle>
            <ReasonDescription>
              {t(`reason ${reason.reason}.description`)}
              {reason.reason === CalendarUnavailableReasonType.Calendar &&
                reason.users.length > 0 &&
                props.viewerUid !== undefined &&
                reason.users[0].uid === props.viewerUid &&
                reason.users[0].providerType &&
                reason.users[0].calendarName && (
                  <>
                    <br />
                    {t(`reason ${reason.reason}.detail`, {
                      provider: providerTypeName(reason.users[0].providerType),
                      address: reason.users[0].calendarName,
                    })}
                  </>
                )}
              {reason.reason === CalendarUnavailableReasonType.Transparent &&
                reason.eventName && (
                  <>
                    <br />
                    {t(`reason ${reason.reason}.detail`, {
                      eventName: reason.eventName,
                    })}
                  </>
                )}
            </ReasonDescription>
          </ReasonItem>
        ))}
      </Content>
    </Dialog>
  );
}

const ActionContainer = styled.div`
  padding-top: ${spacing(24)};
  border-top: 1px solid ${gray04};

  ${mediaMax.tablet} {
    flex-direction: column;
  }
`;
const ShowDetailLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: ${spacing(24)};
  color: ${black};
`;

const Content = styled.div`
  border-top: 1px solid ${gray04};
  padding-top: ${spacing(12)};
`;
const ReasonItem = styled.div`
  border-bottom: 1px solid ${gray04};
  padding-bottom: ${spacing(8)};
  margin-bottom: ${spacing(8)};

  &:last-of-type {
    border-bottom: none;
    padding-bottom: 0;
    margin-bottom: 0;
  }
`;
const ReasonTitle = styled.div`
  margin-bottom: ${spacing(4)};
  font-size: ${fontSize(13)};
  font-weight: ${fontWeight('bold')};
`;
const ReasonDescription = styled.div`
  font-size: ${fontSize(12)};
  color: ${gray01};
`;
